import { useEffect, useEffectEvent } from "react";
import { isEditableTarget } from "../lib/isEditableTarget";

// Match on code because Option can turn the key into a different character.
export function useShiftOptionShortcut(
  code: string,
  onPress: () => void,
  { enabled = true, allowInEditable = false } = {}
) {
  const press = useEffectEvent(onPress);

  useEffect(() => {
    if (!enabled) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.defaultPrevented ||
        e.repeat ||
        e.isComposing ||
        !e.shiftKey ||
        !e.altKey ||
        e.metaKey ||
        e.ctrlKey ||
        e.code !== code ||
        (!allowInEditable && isEditableTarget(e)) ||
        document.querySelector("dialog[open]") ||
        (e.target instanceof Element &&
          e.target.closest('[role="dialog"], [data-popover]'))
      )
        return;
      e.preventDefault();
      press();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [code, enabled, allowInEditable]);
}
